// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForKPITableHeader = makeThemedStyles('KPITable.KPITableHeader', () => ({
  KPITableHeader: {
    display: 'table-row',
    padding: '6px'
  },

  selectable: {
    cursor: 'pointer',
    '&:hover': { textDecoration: 'underline' }
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const KPITableHeader: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForKPITableHeader();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.KPITableHeader, {
        [styles.selectable]: isVariantEnabled(props, 'selectable')
      })}
    >
      {props?.children}
    </div>
  );
};
export default KPITableHeader;
